import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { CatalogService } from '../../catalog.service';
import { ToastrService } from 'ngx-toastr';
import { MatSelectChange } from '@angular/material';
import { MemberData } from '../catalogue-our-team.model';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from '@root/common/confirmation-dialog/confirmation-dialog.component';

@Component({
  selector: 'app-catalouge-list-team-members',
  templateUrl: './catalouge-list-team-members.component.html',
  styleUrls: ['./catalouge-list-team-members.component.scss']
})
export class CatalougeListTeamMembersComponent implements OnInit {


  public selectedFilter = 'All';
  filterOptionList = ['All', 'Team'];
  public selectedSubFilter: string;
  public searchText: string;
  private masterTeamList: any[];
  public TeamList: any[];
  public teams: string[];
  requestInProgress: boolean;
  panelMap: { [key: string]: boolean } = {};
  @Output() editChange: EventEmitter<any> = new EventEmitter<any>();

  constructor(private catalogService:CatalogService, private toastr:ToastrService, private dialog:MatDialog) { }

  ngOnInit() {
    this.readTeamData()
  }

  public readTeamData() {
    this.requestInProgress = true;
    this.catalogService.getTeamMembersList().subscribe(
      (response) => {
        let teamMembersList = []
        if (response.status === 0) {
         response.data.sectionWiseData.forEach(ele=>{
          ele.dataList.forEach(ele1=>{
            ele1['subSectionName'] = ele.subSectionName
          })
          teamMembersList.push(...ele.dataList);
         })
          this.masterTeamList = teamMembersList;
          this.TeamList = teamMembersList;
          this.teams = [];
          const departmentMap: { [key: string]: string } = {};
          this.masterTeamList.forEach((j) => {
            if (j.subSectionName && !departmentMap[j.subSectionName]) {
              this.teams.push(j.subSectionName);
              departmentMap[j.subSectionName] = j.subSectionName;
            }

        });
      }
      else {
        this.toastr.error(response.error.errorMessage);
        this.TeamList = []
      }
        this.requestInProgress = false;
      },
      (error) => {
        this.toastr.error(error.errorMessage);

       

      }
    );
  }
  
  public onChangeSubFilter(change: MatSelectChange) {
    const value = change.value;
    if (value) {
      if (this.selectedFilter === 'Team') {
        this.TeamList = this.masterTeamList.filter(
          (j) => j.subSectionName === this.selectedSubFilter
        );
      } 
    } else {
      this.TeamList = [...this.masterTeamList];
    }
  }

  public onChangeMainFilter(change:MatSelectChange){
    if(change.value==='All'){
      this.TeamList = [...this.masterTeamList];
    }
  }

  public teamMemberEdit(TeamMember: any) {
    this.editChange.emit(TeamMember);
    this.scrollTop();
  }

  public scrollTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }
  
  public openDialog(teamMember: MemberData) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      height: '207px',
      width: '486px',
      data: { teamValue: teamMember , mode: 'DELETE'},
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result.status) {
        this.requestInProgress = true;
        this.catalogService.deleteTeamMember({ id: result.data.id }).subscribe(
          (response) => {
            if (response.status === 0) {
              this.toastr.success(response.message);
              this.readTeamData();
            } else {
              this.toastr.error(response.error.errorMessage);
            }
            this.requestInProgress = false;
          },
          (error) => {
            this.toastr.error(error.error.errorMessage);
            this.requestInProgress = false;
            
          }
        );
      }
    });
  }
}
